export default {
  bg: require('../assets/images/MasaiFamily.jpg'),
  bg2: require('../assets/images/MasaiSunset.jpg'),
  bg3: require('../assets/images/bg.jpg'),
  bg4: require('../assets/images/baobabe-trees.jpg'),
  dashboard: require('../assets/images/undraw_dashboard_nklg.png'),
  campaign: require('../assets/images/undraw_circles_y7s2.png'),
  logo: require('../assets/images/baotree-logo.png'),
  project: require('../assets/images/undraw_project_completed_w0oq.png'),
  sovtechLogo: require('../assets/images/sovtech-small.png'),
  404: require('../assets/images/404.svg'),
  noData: require('../assets/images/no-data.svg'),
  noImage: require('../assets/images/noImage.png'),
  notFound: require('../assets/images/not_found.png'),
  landingPage1: require('../assets/images/undraw_happy_announcement_ac67.png'),
  landingPage3: require('../assets/images/undraw_active_options_8je6.png'),
  landingPage2: require('../assets/images/undraw_message_sent_1030.png'),
  scooterIcon: require('../assets/images/scooter.svg'),
  shopIcon: require('../assets/images/shop.svg'),
  userIcon: require('../assets/images/user.svg'),
  speakerIcon: require('../assets/images/speaker.svg'),
  addFolderIcon: require('../assets/images/add-folder.svg'),
  doneIllustration: require('../assets/images/undraw_done_a34v.png'),
  phoneIllustration: require('../assets/images/undraw_my_app_grf2.svg'),
  clockIcon: require('../assets/images/time.svg'),
  phoneCall: require('../assets/images/phone.svg'),
  welcome: require('../assets/images/Group.svg'),
  navigator: require('../assets/images/undraw_navigator_a479.svg'),
  confetti: require('../assets/images/confetti.gif'),
  upload: require('../assets/images/upload.png'),
  rocket: require('../assets/images/rocket.svg'),
  confirmed: require('../assets/images/undraw_confirmed_81ex.svg'),
  logoNoText: require('../assets/images/logo-no-text.png'),
  iphoneFrame: require('../assets/images/dbsp0oh-e289d163-38a4-49e5-ab3b-9cbe8babe040.png'),
  simulatorScreen: require('../assets/images/Simulator Screen Shot - iPhone 13 Pro - 2022-03-14 at 00.47.48.png'),
  iosDownloadButton: require('../assets/images/App-Store-Button_resize.webp'),
  androidDownloadButton: require('../assets/images/android_badge.png'),
  baotreeIcon: require('../assets/icons/icon.png'),
  baotreeLogo: require('../assets/icons/logo.png'),
  csv: require('../assets/images/icon_file-CSV_plano-512.webp'),
  word: require('../assets/images/word-logo-8.png'),
  excel: require('../assets/images/microsof-excel-logo.png'),
  pdf: require('../assets/images/pdf-icon-png-pdf-zum-download-2.png'),
  powerpoint: require('../assets/images/microsoft-powerpoint-logo.png')
}
